import backend from "../../../../backend/backend";
import label from "../../../../i18n/label";
import Notify from "../../../shared/Notify";
import ToolPluginActions from "./toolPluginActions";

export const createToolPlugin = (
  intl,
  req,
  workspaceId,
  onSuccess,
  onError
) => {
  return (dispatch) => {
    backend
      .createToolPlugin(workspaceId, req)
      .then((data) => {
        dispatch({
          type: ToolPluginActions.LOADED,
          toolPlugin: data,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to create a tool plugin", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const loadToolPlugins = (intl, workspaceId, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .getToolPlugins(workspaceId)
      .then((data) => {
        dispatch({
          type: ToolPluginActions.LIST_LOADED,
          toolPlugins: data,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);

        console.error("Failed to load tool plugins", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const loadToolPlugin = (
  intl,
  workspaceId,
  toolId,
  onSuccess,
  onError
) => {
  return (dispatch) => {
    backend
      .getToolPlugin(workspaceId, toolId)
      .then((data) => {
        dispatch({
          type: ToolPluginActions.LOADED,
          toolPlugin: data,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to load tool plugin", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const updateToolPlugin = (
  intl,
  workspaceId,
  uid,
  toolPlugin,
  onSuccess,
  onError
) => {
  return (dispatch) => {
    backend
      .updateToolPlugin(workspaceId, uid, toolPlugin)
      .then((data) => {
        dispatch({
          type: ToolPluginActions.UPDATED,
          toolPlugin: data,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to update a tool plugin", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const deleteToolPlugin = (
  intl,
  workspaceId,
  uid,
  onSuccess,
  onError
) => {
  return (dispatch) => {
    backend
      .deleteToolPlugin(workspaceId, uid)
      .then((data) => {
        dispatch({
          type: ToolPluginActions.LIST_CHANGED,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to delete a tool plugin", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const loadToolPluginSettings = (
  intl,
  workspaceId,
  onSuccess,
  onError
) => {
  return (dispatch) => {
    backend
      .getToolPluginSettings(workspaceId)
      .then((data) => {
        dispatch({
          type: ToolPluginActions.SETTINGS_LOADED,
          toolPluginSettings: data?.map((setting) => setting.pluginUid),
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);

        console.error("Failed to load tool plugin settings", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const saveToolPluginSettings = (
  intl,
  workspaceId,
  data,
  onSuccess,
  onError
) => {
  return (dispatch) => {
    dispatch({
      type: ToolPluginActions.SETTINGS_CHANGED,
      toolPluginSettings: data,
    });
    backend
      .saveToolPluginSettings(workspaceId, { pluginUids: data })
      .then((data) => {
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to save tool plugin settings", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};
